
document.addEventListener('DOMContentLoaded', setMaxWidth);
naja.addEventListener('success', setMaxWidth);
window.addEventListener('resize', setMaxWidth);

function setMaxWidth() {
  var elements = document.getElementsByClassName('set-max-width');

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];

    var children = element.children;

    for (var j = 0; j < children.length; j++) {
      var child = children[j];
      child.style.display = 'none';
    }

    element.style.maxWidth = '';
    var w = window.getComputedStyle(element, null).getPropertyValue('width');
    element.style.maxWidth = w;

    for (var j = 0; j < children.length; j++) {
      var child = children[j];
      child.style.display = '';
    }

  }
}
